import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "./supabase";

/**
 * Recarrega as consultas quando as tabelas mudam (Supabase Realtime). Rajadas de mudanças
 * viram uma recarga só a cada `intervaloMs` (telas que leem muita coisa, como o painel,
 * usam um intervalo maior para não recarregar a cada bipagem do galpão).
 */
export function useTempoReal(tabelas: string[], chaves: string[][], intervaloMs = 800) {
  const cliente = useQueryClient();
  const assinatura = tabelas.join(",");
  useEffect(() => {
    let espera: ReturnType<typeof setTimeout> | null = null;
    const canal = supabase.channel(`tempo-real-${assinatura}`);
    for (const tabela of tabelas) {
      canal.on("postgres_changes", { event: "*", schema: "public", table: tabela }, () => {
        if (espera) return;
        // junta rajadas de mudanças numa recarga só
        espera = setTimeout(() => {
          espera = null;
          for (const chave of chaves) void cliente.invalidateQueries({ queryKey: chave });
        }, intervaloMs);
      });
    }
    canal.subscribe();
    return () => {
      if (espera) clearTimeout(espera);
      void supabase.removeChannel(canal);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assinatura, intervaloMs]);
}
